<template>
    <span>
        <div class="py-5 upcoming-events" :style="{backgroundImage: 'url(' + require('@/assets/img_8.jpg')+')',
                                                backgroundAttachment:'fixed',
                                                height:'60vh', 
                                                backgroundSize: 'cover' }">
            <div style="height:100%" class="container">
                <div style="text-align:center;position:relative;height:100% " class="row align-items-center ">
                    <div class="col-md-12 vertically-centered">
                        <h4 style="display:inline-block" class="text-white stroke">{{$t('NewsLetter["Mensaje"]')}}</h4>
                        <div class="row">
                            <input type="text" class="form-control col-md-5" v-model="name" :placeholder="$t('NewsLetter.NombrePlaceholder')">
                            <input type="text" class="form-control col-md-5" v-model="correo" :placeholder="$t('NewsLetter.MailPlaceholder')">
                            <button @click="SendMail()" value="Enviar Mensaje" class="btn btn-primary pill green col-md-2">{{$t('NewsLetter["Boton"]')}}</button>
                        </div>
                        <!-- <h2 style="display:inline-block" class="text-white stroke">¡Disfrute de lo mejor de Lima en nuestros hoteles!</h2> -->
                    </div> 
                                
                </div>
            </div> 
                      
        </div>        
    </span>
</template>

<script>
import Vue from 'vue'
import axios from 'axios';
import newsLetter from './../MailTemplates/NewsLetter.vue'

export default {
    name: "Parallax",
    data () {
      return {
        name: null,
        correo: null,
      }
    },
    methods: {        
        async SendMail () {  
            this.$message({
                //validar el locale para ver que mensaje mostrar
                //if(LS.locale == 'en')
                messageEn: 'Your message is being send, please be patiente, thank you.',
                //else
                message: 'Su mensaje esta siendo enviado, porfavor espere, gracias.',
                type: 'info'
            });
            if(isNaN(this.name) && this.name === null)
            {
                this.message = "Estimado, necesitamos que nos diga su nombre para saber como llamarlo"
                this.failure()
                return
            }            
            if( this.correo === null || !this.validateEmail(this.correo))
            {
                this.message = "Tiene que dejar su correo para poder comunicarnos con usted"
                this.failure()
                return
            }            

            const vistaHotel = new Vue({
                render: h => h(newsLetter, {
                    props: {
                        name: this.name,
                        emailCliente: this.email
                    }
                })
            })

            const htmlHotel = vistaHotel.$mount().$el.outerHTML

            let url = 'https://ctws.azurewebsites.net/MailApi/SendEmail/?x=Nno2ufull9A2O8hO8jEEijE2PgrsB79Wzybiaysq0sOW+9TEtsf1gVigYt59z363ArlqzybbPLRNci9NHHYFBbU2SHL6oxmf5tDYcuWxVwGo1rqAclluxoYpCpzWI4EeDLCtoqJPsLMZe0K81uK+H2bBTygUlWAmkw04xVF+yVbp93b4h6vC3I/7GXPqjUD+yX2mWfPwms72J85WU2Q5IfoAeNp5V26KAukPUS5iFnM8D2qCzL+nBLVGDoU81PRUNCspnKeyf4RkdkBxxKBpEfDTcTwDmw9cnC8UTVv4n22er/rWbPQDdsoqpEukRlm8L+Iu5Ug0Rl+/QmJvyG1GqOYcdXVqsBKmW3tKm3AaYvZo1jfAZBQGy7BjDG3uyAku';
            
            const jsonSendHotel = {
                "emailTo":[               
                    this.datosHotel.email
                ],
                "emailFrom" :  'notificaciones@chevere.tech',
                "subject" : "Nuevo cliente suscrito al newsletter: "+this.name,
                "body" :  btoa(htmlHotel),
                "attachments" : null
            }            

            let configHotel = {
                method: 'post',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'Content-Type': 'application/json'
                },
                data : jsonSendHotel
            };

            axios.request(configHotel)
            .then((response) => {
                this.success(); 
            })
            .catch((error) => {
                this.failure();    
            });            
        },
        failure() {            
            this.$message.error(this.message);
        },
        validateEmail(email) {
            const re = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
            return re.test(email);
        },
        success() {
            this.$message({
            message: '¡Se ha registrado exitosamente a nuestra newsletter!.',
            type: 'success'
            });
            this.name= null;
            this.correo= null;
        }
    }
}
</script>

<style scoped>
    .green{
        background-color: rgb(11,119,61);
        border: 1px solid rgb(11,119,61);
    }
    .vertically-centered{
        margin: 0;
        position: absolute;
        top: 50%;
        left: 50%;
        -ms-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
    }
    .stroke{
        background-color:rgba(81, 81, 81, .5);
        padding:20px;
    }
</style>


// WEBPACK FOOTER //
// Parallax.vue?35922357